export function isChatGifImageUrl(url: string): boolean {
  return /\.gif($|\?|#)/i.test(url);
}
